export default "__VITE_ASSET__BGqSaiUl__"